import React from 'react';
import { isEmpty } from 'lodash';
import { Image } from 'Components/frameworks/image/Image';
export type TripAdvisorRatingsProps = {
  className?: string;
  counterLabel?: string;
  counterUnit?: string;
  counterValue?: string;
  image?: {};
  subratings: Array<{
    localizedName: string;
    ratingImageUrl: string;
    value: number;
  }>;
};
export const TripAdvisorRatings = ({
  className,
  counterLabel,
  counterUnit,
  counterValue,
  image = {},
  subratings = [],
}: TripAdvisorRatingsProps) => {
  if (isEmpty(subratings)) {
    return null;
  }

  return (
    <section className={className}>
      <div className="flex items-center justify-center">
        {!isEmpty(image) ? <Image className="my-5" dontChangeAnything {...image} /> : null}
        <span>&nbsp;</span>
        <p className="text-14">
          {counterLabel}
          <span> </span>
          <span className="text-[#429E96]">{[counterValue, counterUnit].join(' ')}</span>
        </p>
      </div>
      <ul className="mx-auto mt-30 w-[290px] px-5">
        {subratings.map(({ localizedName, ratingImageUrl, value }) => {
          if (isEmpty(subratings[0])) {
            return null;
          }

          return (
            <li
              className="mx-auto mt-5 flex w-full items-center justify-between gap-5"
              key={localizedName}
            >
              <span className="leading-1">{localizedName}</span>
              <span className="w-80 leading-0">
                <Image
                  className="w-full"
                  classNameImg="max-h-16 w-full"
                  altMsg={`${value}`}
                  dontChangeAnything
                  imageUrl={ratingImageUrl}
                  dimensions={{
                    w: 80,
                    h: 17,
                  }}
                />
              </span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};
